import React, { useEffect, useState } from "react";
import { ButtonHLPure, DropDownBtnHLPure, ComboBoxTemplatePure } from "../../pures";
import { TreeView, processTreeViewItems } from '@progress/kendo-react-treeview';
import { NIL as NIL_UUID } from 'uuid';
import { useTranslation } from "react-i18next";
import './questionnaires-assign-categories.css';

const QuestionnnairesAssignCategories = (porps) => {

    let {
        userCompanies,
        categories,
        subCategories,
        typeDocuments,
        handleBackView,
        handleAssignCategories,
        selectedQuestionnaire,
        hideShowDetails,
        getUserCategories,
        getUserSubcategires,
        setDigitalVaultCategory,
        onExpandTree
    } = porps

    const { t } = useTranslation();


    const [select, setSelect] = useState([""]);
    const [companyId, setCompanyId] = useState(NIL_UUID)
    const [showErrorCategories, setShowErrorCategories] = useState(false)
    const [categoryId, setCategoryId] = useState(0)
    const [showErrorSub, setShowErrorSub] = useState(false)
    const [typeDocument, setTypeDocument] = useState('')
    const [showErrorComboBox, setShowComboBox] = useState(false)
    const [showErrorCompany, setShowErrorCompany] = useState(false)
    const [showErrorTypeDoc, setShowTypeDoc] = useState(false)
    const [companyDisable, setCompanyDisable] = useState(true)
    const [expand, setExpand] = useState({
        ids: [],
        idField: "subcategory.id",
    });

    useEffect(() => {
        let companyDisable = (selectedQuestionnaire && selectedQuestionnaire.classifier && selectedQuestionnaire.classifier.companyId && selectedQuestionnaire.classifier.companyId !== NIL_UUID) ? true : false
        setCompanyDisable(companyDisable)
        setDigitalVaultCategory(selectedQuestionnaire, setCompanyId, setTypeDocument, setCategoryId, setSelect, setExpand)
    }, [])

    const handleChange = (e, setValue, type, setShowError, typeSelect) => {
        let value = e.target.value
        if (type === 'Number') value = Number(value)
        if (setShowError) setShowError(false)
        setValue(value)

        if (typeSelect === 'company') {
            getUserCategories(value, setCategoryId, setSelect)
        }

        if (typeSelect === 'category') {
            getUserSubcategires(companyId, value, setSelect)
        }

    }

    const onItemClick = (event) => {
        setSelect([event.itemHierarchicalIndex]);
        setShowErrorSub(false)
    };

    const handleAssignSave = () => {
        if (companyId === NIL_UUID) {
            setShowErrorCompany(true)
            return
        }

        if (categoryId === 0) {
            setShowErrorCategories(true)
            return
        }

        if (select[0] === "") {
            setShowErrorSub(true)
            return
        }

        if (!typeDocument) {
            setShowTypeDoc(true)
            return
        }

        let pathBreadcrumb = ''
        let subCategoryId = 0
        let subSplit = select[0].split('_')

        if(subSplit && subSplit.length === 1){
            let subcategory = subCategories[select[0]]
            subCategoryId = subcategory.subcategory.id
            pathBreadcrumb = `${subcategory.subcategory.id}`
        }

        if(subSplit && subSplit.length === 2){
            let catIndex = (subSplit) ? subSplit[0] : 0
            let subIndex = (subSplit) ? subSplit[1] : 1
            let catFind = subCategories[catIndex]
            let subcategoryFind = catFind.items[subIndex]
            subCategoryId = subcategoryFind.subcategory.id
            pathBreadcrumb = `${catFind.subcategory.id}/${subCategoryId}`
        }

        if(subSplit && subSplit.length === 3){
            let catIndex = (subSplit) ? subSplit[0] : 0
            let subIndex = (subSplit) ? subSplit[1] : 0
            let subSubIndex = (subSplit) ? subSplit[2] : 0
            let catFind = subCategories[catIndex]
            let subcategoryFind = catFind.items[subIndex]
            let subSubFind = subcategoryFind.items[subSubIndex]
            subCategoryId = subSubFind.subcategory.id
            pathBreadcrumb = `${catFind.subcategory.id}/${subcategoryFind.subcategory.id}/${subCategoryId}`
        }

        let data = {
            solicitudeId: selectedQuestionnaire.id,
            companyId,
            categoryId,
            subCategoryId,
            typeDocument: typeDocument,
            pathBreadcrumb
        }
        handleAssignCategories(data, hideShowDetails)
    }

    const handleBack = () => {
        hideShowDetails()
        handleResetCategory()
    }

    const handleResetCategory = () => {
        setCompanyId(NIL_UUID)
        setCategoryId(0)
        setTypeDocument('')
        setSelect([""])
    }

    const onTreeExpandChange = (event) => {
        let ids = expand.ids.slice();
        const index = ids.indexOf(event.item.subcategory.id);
        index === -1 ? ids.push(event.item.subcategory.id) : ids.splice(index, 1);
        setExpand({
            ids,
            idField: "subcategory.id",
        });
    };

    const onChangeTree = (event) => {
        setSelect([event.itemHierarchicalIndex]);
    }

    return (
        <div className="questionnairesAssignCategories-container">
            <div className="questionnairesAssignCategories-elements">
                <div className="questionnairesAssignCategories-inputs">
                    <div className="questionnaireAssignCategories-subtitle">
                        <p className="questionnairesAssignCategories-label-title">{t("digitalContractDashboard.questionnaires.assignCategoryTitle")}</p>
                    </div>
                    <div>
                        <DropDownBtnHLPure
                            labelDropDown={t("questionnairesAssignCategories.company")}
                            optionsDropDown={userCompanies}
                            optionsValue={companyId}
                            valueItem={"id"}
                            nameOption={"companyName"}
                            onDropDownChange={(e) => handleChange(e, setCompanyId, null, setShowErrorCompany, 'company')}
                            required
                            disable={companyDisable}
                        />
                        {
                            showErrorCompany &&
                            <p className='hint-message-error'>{`${t("questionnairesAssignCategories.company.error")}`}</p>
                        }
                    </div>

                    <div>
                        <DropDownBtnHLPure
                            labelDropDown={t("questionnairesAssignCategories.category")}
                            optionsDropDown={categories}
                            optionsValue={categoryId}
                            valueItem={"id"}
                            nameOption={"name"}
                            onDropDownChange={(e) => handleChange(e, setCategoryId, 'Number', setShowErrorCategories, 'category')}
                            required
                        />
                        {
                            showErrorCategories &&
                            <p className='hint-message-error'>{`${t("questionnairesAssignCategories.category.error")}`}</p>
                        }
                    </div>

                    <div className="questionnairesAssignCategories-subcategory">
                        <p className="questionnairesAssignCategories-inputHLPure-label">{`${t("questionnairesAssignCategories.subcategory")}`}</p>
                        {!subCategories || subCategories.length === 0 || !subCategories[0].subcategory || !subCategories[0].subcategory.id
                            ? <p className='questionnairesAssignCategories-not-assigned'>{`${t("questionnairesAssignCategories.no.assign")}`}</p>
                            :  <TreeView
                                    data={processTreeViewItems(subCategories, {
                                        select: select,
                                        expand: expand,
                                    })}
                                    expandIcons
                                    size={"medium"}
                                    textField='subcategory.name'
                                    onExpandChange={onTreeExpandChange}
                                    onItemClick={(e) => onChangeTree(e)}
                                />
                        }
                        {
                            showErrorSub &&
                            <p className='hint-message-error'>{`t("questionnairesAssignCategories.subcategory.error)`}</p>
                        }

                    </div>
                    <div className="questionnairesAssignCategories-type-document">
                        <ComboBoxTemplatePure
                            title={t("questionnairesAssignCategories.type.document")}
                            placeholder={t("questionnairesAssignCategories.select.type.document")}
                            allowCustom
                            data={typeDocuments}
                            textField="name"
                            dataItemKey="id"
                            value={typeDocument}
                            onChange={(e) => handleChange(e, setTypeDocument, null, setShowTypeDoc)}
                            required
                            validityStyles={false}
                            errorCombobox={showErrorComboBox}
                            errorMessage={t("questionnairesAssignCategories.error.type.document")}
                        />
                        {
                            showErrorTypeDoc &&
                            <p className='hint-message-error'>{t("questionnairesAssignCategories.error.type.document")}</p>
                        }
                    </div>
                </div>
                <div className="questionnairesAssignCategories-btns">
                    <div className="questionnairesAssignCategories-btn-back">
                        <ButtonHLPure
                            nameBtn={t("button.return")}
                            primary={false}
                            onClickBtn={() => handleBack()}
                        />
                    </div>

                    <ButtonHLPure
                        nameBtn={t("button.save")}
                        primary={true}
                        onClickBtn={() => handleAssignSave()}
                    />
                </div>
            </div>
        </div>
    )
}

export { QuestionnnairesAssignCategories as default }